/* Content Hub — inline video modal, carousel arrows, category filter, search */
(function () {
  'use strict';

  /* ---- HERO REEL — duplicate items for infinite scroll + click to open ---- */
  var reelTrack = document.querySelector('.content-hub__hero-reel-track');
  if (reelTrack) {
    var reelItems = reelTrack.innerHTML;
    reelTrack.innerHTML = reelItems + reelItems;
  }

  /* ---- HERO VIDEO (Netflix autoplay — right-side box) ---- */
  var heroPlayer = null;
  var heroVideoEl = document.getElementById('content-hub-hero-video');
  var heroVideoWrap = document.getElementById('content-hub-hero-video-wrap');
  var heroMuteBtn = document.getElementById('content-hub-hero-mute');
  var isMobile = window.matchMedia('(max-width: 767px)').matches;

  var heroVideoId = heroVideoEl ? heroVideoEl.getAttribute('data-hero-video-id') : '';
  if (!heroVideoId) {
    var heroCta = document.querySelector('.content-hub__hero-cta[data-video-id]');
    heroVideoId = heroCta ? heroCta.getAttribute('data-video-id') : '';
  }

  if (!isMobile && heroVideoId && heroVideoEl) {
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);

    var _prevOnReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (_prevOnReady) _prevOnReady();
      setTimeout(function () {
        heroPlayer = new YT.Player('content-hub-hero-video', {
          videoId: heroVideoId,
          playerVars: {
            autoplay: 1,
            mute: 1,
            controls: 0,
            showinfo: 0,
            modestbranding: 1,
            loop: 1,
            playlist: heroVideoId,
            rel: 0,
            playsinline: 1,
            disablekb: 1,
            iv_load_policy: 3,
            origin: window.location.origin
          },
          events: {
            onReady: function (e) {
              e.target.mute();
              e.target.playVideo();
            },
            onStateChange: function (e) {
              if (e.data === YT.PlayerState.PLAYING) {
                if (heroVideoWrap) heroVideoWrap.classList.add('is-playing');
                if (heroMuteBtn) heroMuteBtn.style.display = 'flex';
              }
            }
          }
        });
      }, 3000);
    };

    /* Click hero video → open in modal with sound */
    if (heroVideoWrap) {
      heroVideoWrap.addEventListener('click', function (e) {
        if (e.target.closest('.content-hub__hero-mute')) return;
        var heroCta = document.querySelector('.content-hub__hero-cta[data-video-id]');
        var title = heroCta ? heroCta.getAttribute('data-video-title') : '';
        var meta = heroCta ? heroCta.getAttribute('data-video-meta') : '';
        openVideo(heroVideoId, title, meta);
      });
    }

    /* Scroll pause/resume */
    if ('IntersectionObserver' in window) {
      var heroEl = document.querySelector('.content-hub__hero');
      var heroObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!heroPlayer || typeof heroPlayer.pauseVideo !== 'function') return;
          if (entry.isIntersecting) {
            heroPlayer.playVideo();
          } else {
            heroPlayer.pauseVideo();
          }
        });
      }, { threshold: 0.25 });
      if (heroEl) heroObserver.observe(heroEl);
    }

    /* Mute/unmute toggle */
    if (heroMuteBtn) {
      var muteIconOff = heroMuteBtn.querySelector('.content-hub__hero-mute-icon--off');
      var muteIconOn = heroMuteBtn.querySelector('.content-hub__hero-mute-icon--on');
      heroMuteBtn.addEventListener('click', function () {
        if (!heroPlayer) return;
        if (heroPlayer.isMuted()) {
          heroPlayer.unMute();
          if (muteIconOff) muteIconOff.style.display = 'none';
          if (muteIconOn) muteIconOn.style.display = 'block';
          heroMuteBtn.setAttribute('aria-label', 'Mute video');
        } else {
          heroPlayer.mute();
          if (muteIconOff) muteIconOff.style.display = 'block';
          if (muteIconOn) muteIconOn.style.display = 'none';
          heroMuteBtn.setAttribute('aria-label', 'Unmute video');
        }
      });
    }
  }

  /* ---- INLINE VIDEO MODAL ---- */
  var modal = document.getElementById('content-hub-modal');
  var modalPlayer = document.getElementById('content-hub-modal-player');
  var modalTitle = document.getElementById('content-hub-modal-title');
  var modalMeta = document.getElementById('content-hub-modal-meta');
  var modalClose = document.getElementById('content-hub-modal-close');
  var modalX = document.getElementById('content-hub-modal-x');

  function openVideo(videoId, title, meta) {
    if (!modal || !modalPlayer) return;
    modalPlayer.innerHTML = '<iframe src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen style="width:100%;aspect-ratio:16/9;border-radius:8px 8px 0 0;display:block;"></iframe>';
    if (modalTitle) modalTitle.textContent = title || '';
    if (modalMeta) modalMeta.innerHTML = meta || '';
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (heroPlayer && typeof heroPlayer.pauseVideo === 'function') heroPlayer.pauseVideo();
  }

  function closeVideo() {
    if (!modal) return;
    modal.classList.remove('active');
    if (modalPlayer) modalPlayer.innerHTML = '';
    document.body.style.overflow = '';
    if (heroPlayer && typeof heroPlayer.playVideo === 'function') heroPlayer.playVideo();
  }

  if (modalClose) modalClose.addEventListener('click', closeVideo);
  if (modalX) modalX.addEventListener('click', closeVideo);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeVideo();
  });

  /* Attach click to all video elements in a container */
  function bindVideoClicks(container) {
    container.querySelectorAll('[data-video-id]').forEach(function (el) {
      if (el._videoBound) return;
      el._videoBound = true;
      el.style.cursor = 'pointer';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openVideo(
          el.getAttribute('data-video-id'),
          el.getAttribute('data-video-title'),
          el.getAttribute('data-video-meta')
        );
      });
    });
  }
  bindVideoClicks(document);

  /* ---- Carousel arrow navigation ---- */
  function updateArrows(carousel, left, right) {
    var scrollLeft = carousel.scrollLeft;
    var maxScroll = carousel.scrollWidth - carousel.clientWidth;
    left.style.opacity = scrollLeft <= 5 ? '0' : '1';
    left.style.pointerEvents = scrollLeft <= 5 ? 'none' : 'auto';
    right.style.opacity = scrollLeft >= maxScroll - 5 ? '0' : '1';
    right.style.pointerEvents = scrollLeft >= maxScroll - 5 ? 'none' : 'auto';
  }

  function initCarouselArrows(wrap) {
    if (wrap._arrowsBound) return;
    wrap._arrowsBound = true;
    var carousel = wrap.querySelector('[data-carousel]');
    var left = wrap.querySelector('.content-hub__arrow--left');
    var right = wrap.querySelector('.content-hub__arrow--right');
    var scrollAmount = 540;

    if (left && right && carousel) {
      left.style.transition = 'opacity 0.2s';
      right.style.transition = 'opacity 0.2s';
      updateArrows(carousel, left, right);

      carousel.addEventListener('scroll', function () {
        updateArrows(carousel, left, right);
      });

      carousel.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          e.preventDefault();
          window.scrollBy(0, e.deltaY);
        }
      }, { passive: false });

      left.addEventListener('click', function () {
        carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      right.addEventListener('click', function () {
        carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  }
  document.querySelectorAll('.content-hub__carousel-wrap').forEach(initCarouselArrows);

  /* ---- Category filter nav ---- */
  var nav = document.getElementById('content-hub-nav');
  if (!nav) return;

  var buttons = nav.querySelectorAll('.content-hub__nav-btn');
  var rows = document.querySelectorAll('.content-hub__row');

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      buttons.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      var filter = btn.getAttribute('data-filter');

      rows.forEach(function (row) {
        if (filter === 'all' || row.getAttribute('data-category') === filter) {
          row.classList.remove('hidden');
        } else {
          row.classList.add('hidden');
        }
      });

      var searchInput = document.getElementById('content-hub-search');
      if (searchInput) searchInput.value = '';
      document.querySelectorAll('.content-hub__card').forEach(function (card) {
        card.style.display = '';
      });

      if (filter !== 'all') {
        var target = document.querySelector('.content-hub__row[data-category="' + filter + '"]');
        if (target) {
          var filterBar = document.querySelector('.content-hub__filter-bar');
          var offset = filterBar ? filterBar.offsetHeight + 8 : 0;
          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }
    });
  });

  /* ---- Search ---- */
  var searchInput = document.getElementById('content-hub-search');
  if (searchInput) {
    var debounceTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var query = searchInput.value.toLowerCase().trim();

        rows.forEach(function (row) { row.classList.remove('hidden'); });
        buttons.forEach(function (b) { b.classList.remove('active'); });
        nav.querySelector('[data-filter="all"]').classList.add('active');

        if (!query) {
          document.querySelectorAll('.content-hub__card').forEach(function (card) {
            card.style.display = '';
          });
          rows.forEach(function (row) { row.classList.remove('hidden'); });
          return;
        }

        rows.forEach(function (row) {
          var cards = row.querySelectorAll('.content-hub__card');
          var visibleCount = 0;

          cards.forEach(function (card) {
            var title = (card.querySelector('.content-hub__card-title') || {}).textContent || '';
            var meta = (card.querySelector('.content-hub__card-meta') || {}).textContent || '';
            var match = title.toLowerCase().indexOf(query) !== -1 || meta.toLowerCase().indexOf(query) !== -1;

            card.style.display = match ? '' : 'none';
            if (match) visibleCount++;
          });

          if (visibleCount === 0) {
            row.classList.add('hidden');
          }
        });
      }, 200);
    });
  }

  /* ---- Klaviyo Subscribe Helper ---- */
  var isCanada = window.location.hostname.indexOf('martinclinic.com') !== -1 && window.location.hostname.indexOf('us.martinclinic.com') === -1;
  var KLAVIYO_COMPANY_ID = isCanada ? 'MvUqmM' : 'X4AEgj';
  var KLAVIYO_LIST_ID = isCanada ? 'HrjwTB' : 'XzkYSD';

  function subscribeToKlaviyo(email, source, btn) {
    var originalText = btn ? btn.textContent : '';
    if (btn) {
      btn.textContent = 'Subscribing...';
      btn.disabled = true;
    }

    return fetch('https://a.klaviyo.com/client/subscriptions/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    'Content Hub Source': source
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_LIST_ID
              }
            }
          }
        }
      })
    }).then(function () {
      if (btn) {
        btn.textContent = 'Subscribed!';
        btn.style.background = '#27ae60';
      }
      return true;
    }).catch(function () {
      if (btn) {
        btn.textContent = originalText;
        btn.disabled = false;
      }
      return false;
    });
  }

  /* ---- Gated Webinar Section ---- */
  var gatedRow = document.getElementById('content-hub-gated');
  var gateForm = document.getElementById('content-hub-gate-form');
  var gateEmail = document.getElementById('content-hub-gate-email');

  function unlockGated() {
    if (gatedRow) {
      gatedRow.classList.add('unlocked');
      gatedRow.querySelectorAll('.content-hub__card--gated').forEach(function (card) {
        card.style.cursor = 'pointer';
        card.addEventListener('click', function (e) {
          e.preventDefault();
          var id = card.querySelector('img').src.match(/\/vi\/([^/]+)\//);
          if (id && id[1]) {
            openVideo(id[1], card.querySelector('.content-hub__card-title').textContent, card.querySelector('.content-hub__card-meta').innerHTML);
          }
        });
      });
    }
  }

  if (localStorage.getItem('ch_gated_unlocked') === '1') {
    unlockGated();
  }

  if (gateForm) {
    gateForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = gateEmail ? gateEmail.value.trim() : '';
      if (!email) return;
      var btn = gateForm.querySelector('button[type="submit"]');

      subscribeToKlaviyo(email, 'Content Hub - Webinars', btn).then(function () {
        localStorage.setItem('ch_gated_email', email);
        /* Show confirmation — content is coming soon, don't unlock */
        var overlay = document.getElementById('content-hub-gate-overlay');
        if (overlay) {
          overlay.querySelector('.content-hub__gated-title').textContent = "You're on the list!";
          overlay.querySelector('.content-hub__gated-desc').textContent = "We'll email you as soon as the masterclasses are ready.";
          gateForm.style.display = 'none';
          var privacy = overlay.querySelector('.content-hub__gated-privacy');
          if (privacy) privacy.style.display = 'none';
        }
      });
    });
  }

  document.querySelectorAll('.content-hub__card--gated').forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (!gatedRow || !gatedRow.classList.contains('unlocked')) {
        e.preventDefault();
        e.stopPropagation();
        if (gateEmail) gateEmail.focus();
      }
    });
  });

  /* ---- Gated Courses Section ---- */
  var coursesRow = document.getElementById('content-hub-gated-courses');
  var coursesForm = document.getElementById('content-hub-gate-courses-form');
  var coursesEmail = document.getElementById('content-hub-gate-courses-email');

  function unlockCourses() {
    if (coursesRow) {
      coursesRow.classList.add('unlocked');
      coursesRow.querySelectorAll('.content-hub__card--gated-course').forEach(function (card) {
        card.style.cursor = 'pointer';
        card.addEventListener('click', function (e) {
          e.preventDefault();
          var id = card.querySelector('img').src.match(/\/vi\/([^/]+)\//);
          if (id && id[1]) {
            openVideo(id[1], card.querySelector('.content-hub__card-title').textContent, card.querySelector('.content-hub__card-meta').innerHTML);
          }
        });
      });
    }
  }

  if (localStorage.getItem('ch_courses_unlocked') === '1') {
    unlockCourses();
  }

  if (coursesForm) {
    coursesForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = coursesEmail ? coursesEmail.value.trim() : '';
      if (!email) return;
      var btn = coursesForm.querySelector('button[type="submit"]');

      subscribeToKlaviyo(email, 'Content Hub - Courses', btn).then(function () {
        localStorage.setItem('ch_courses_email', email);
        /* Show confirmation — content is coming soon, don't unlock */
        var overlay = document.getElementById('content-hub-gate-courses-overlay');
        if (overlay) {
          overlay.querySelector('.content-hub__gated-title').textContent = "You're on the list!";
          overlay.querySelector('.content-hub__gated-desc').textContent = "We'll notify you when the courses launch.";
          coursesForm.style.display = 'none';
          var privacy = overlay.querySelector('.content-hub__gated-privacy');
          if (privacy) privacy.style.display = 'none';
        }
      });
    });
  }

  document.querySelectorAll('.content-hub__card--gated-course').forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (!coursesRow || !coursesRow.classList.contains('unlocked')) {
        e.preventDefault();
        e.stopPropagation();
        if (coursesEmail) coursesEmail.focus();
      }
    });
  });
})();
